import { css } from '@emotion/react';
import { MissingProductPhotoIcon } from './MissingProductPhotoIcon';
import { NotesCountBubble } from './NotesCountBubble';

const productThumbnailContainerStyle = (size: number) =>
  css`
  label: PRODUCT_THUMBNAIL_CONTAINER_STYLE;
  width: ${size}px;
  height: ${size}px;
  position: relative;
`;
const PRODUCT_THUMBNAIL_CONTAINER_STYLE_NO_PHOTO = css`
  label: PRODUCT_THUMBNAIL_CONTAINER_STYLE_NO_PHOTO;
  background: var(--background3);
`;

const productThumbnailStyle = (size: number) =>
  css`
  label: PRODUCT_THUMBNAIL_STYLE;
  width: ${size}px;
  height: ${size}px;
  object-fit: cover;
  border: 1px solid #0000007f;
`;

export const ProductThumbnail = (
  { uri, alt, photoCount, onClick, size = 80 }: { uri: string | undefined; alt?: string; photoCount: number; onClick?: () => void; size?: number },
) => (
  <div
    css={[productThumbnailContainerStyle(size), !uri && PRODUCT_THUMBNAIL_CONTAINER_STYLE_NO_PHOTO]}
    onClick={onClick}
    style={{ cursor: onClick ? 'pointer' : 'default' }}
  >
    {uri
      ? <img src={uri} alt={alt} css={productThumbnailStyle(size)} />
      : <MissingProductPhotoIcon />}
    {photoCount >= 2 && <NotesCountBubble count={photoCount} backgroundColor='var(--background)' />}
  </div>
);
